import { render, staticRenderFns } from "./select_continuing_studies_type.vue?vue&type=template&id=7484f466&scoped=true"
import script from "./select_continuing_studies_type.vue?vue&type=script&lang=js"
export * from "./select_continuing_studies_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7484f466",
  null
  
)

export default component.exports